import React, { useEffect, useState } from 'react';
import { message, Modal, Spin } from 'antd';
import { PermError } from '../NotFoundPage/PermError';
import TextArea from 'antd/es/input/TextArea';
import { fetcher } from '../../../extras/fetcher';
import { PersonLockerInterface } from '../../../types/personLocker.interface';


interface Props {
  open: boolean;
  handleSetModalOpened: (opened: boolean) => void;
  handleGetData: () => void;

  employeeId: string;
}

export const ModalEditEmployeeComments = (props: Props) => {

  const [moveLoading, setMoveLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [messageApi, contextHolder] = message.useMessage();
  const [permError, setPermError] = useState<boolean>(false);
  const [employeeData, setEmployeeData] = useState<PersonLockerInterface>();


  const getData = async () => {
    await fetcher(`person/employees/${props.employeeId}`)
      .then(res => {
        if (res.status === 403) {
          setLoading(false);
          setPermError(true);
          return;
        }


        if (res.result.error) {
          setLoading(false);
          return Modal.error({
            title: 'Błąd',
            content: res.result.error,
          });

        }



        setEmployeeData(res.result);

      })

  }

  useEffect(() => {
    setLoading(true);
    getData().then(r => setLoading(false));
  }, [props.employeeId]);


  const handleCancel = async () => {
    props.handleSetModalOpened(false);
  };

  const onChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {

    setEmployeeData((data) => {
      if (data) {
        return {
          ...data,
          comments: e.target.value,
        }
      }

    });
  };

  const handleOk = async () => {
    const data = await fetcher(`person/employees/${props.employeeId}/comments`, 'PUT', {employeeId: props.employeeId, comments: employeeData?.comments});

    if (data.status === 403) {
      messageApi.error('Brak wymaganych uprawnień!');
    }

    if(data.result.error) {
      messageApi.error(data.result.error);
      return;
    }

    if(data.result.success) {
      messageApi.success('Komentarz został zmieniony!');
      props.handleSetModalOpened(false);
      props.handleGetData();
    } else {
      messageApi.error('Nieznany błąd!');
    }

  }

  if(permError) {
    return <PermError/>
  }

  return (
    <Modal bodyStyle={{padding: 10}} title={`${employeeData?.name} - Zmiana Komentarza`} open={props.open} onOk={handleOk}
           onCancel={handleCancel} confirmLoading={moveLoading}>
      {
        loading ? <div style={{textAlign: 'center'}}>
          <Spin size="large" />

      </div> : <>
      {permError ? <PermError/> : <>
        <h4>Komentarz</h4>
        <TextArea value={employeeData?.comments} rows={4} onChange={onChangeTextArea}/>
        {contextHolder}
      </>}

</>
     }
    </Modal>

  );

};
